import React from 'react'
import Tooltip from './Tooltip'
import { Trash } from 'lucide-react'

const DeleteButton = ({ handleClick, isDisabled }: { handleClick: () => void; isDisabled?: boolean }) => {
    return (
        <div className='flex'>
            <Tooltip label={isDisabled ? 'Exclusão desabilitada' : 'Excluir cadastro'} placement='bottom'>
                <button
                    onClick={handleClick}
                    className='bg-error-100 hover:bg-error-200 text-error-400 dark:bg-error-400/[0.12] dark:hover:bg-error-400/[0.23] dark:text-error-400 py-2 px-3 flex items-center gap-1 rounded-full disabled:opacity-50 disabled:cursor-not-allowed'
                    disabled={isDisabled}
                >
                    <Trash size={14} />
                    <p>Excluir</p>
                </button>
            </Tooltip>
        </div>
    )
}

export default DeleteButton
